import { useWindowDimensions, View } from 'react-native';
import { brand, neutrals } from 'src/theme/colors';
import { useStore } from 'src/contexts/StoreContext';
import { style } from './DiscountInfo.style';
import { Icon } from '@photosi/rn-components/icon/Icon';
import { ICON_NAMES } from '@photosi/rn-components/icon/icon.helper';
import TextLato from '@photosi/rn-components/text/text-lato/TextLato';
import { DiscountScale } from '@photosi/expo-photosi-sdk/build/Project';
import { getFormattedPrice } from 'src/helpers/price.helper';
import useResponsiveScreen from 'src/hooks/useResponsiveScreen';

type DiscountInfoProps = {
  discount: DiscountScale[];
  onPress?: () => void;
};

const MAX_PHOTOS = 9999;

export const DiscountInfo = ({ discount, onPress }: DiscountInfoProps) => {
  const { i18n } = useStore();
  const { isDesktop, isSmallDesktop } = useResponsiveScreen();
  const { width } = useWindowDimensions();
  const widthSize = isDesktop ? width * 0.2 : width * 0.9;

  return (
    <View style={[style.container, { width: widthSize }]}>
      {isDesktop && (
        <View style={[style.leftElement, isDesktop ? { gap: 16 } : { gap: 4, width: '90%' }]}>
          <Icon
            name={isDesktop ? ICON_NAMES.Promo : ICON_NAMES.DiscountSimpleV3}
            color={brand.main.orange}
            width={32}
            height={32}
          />
          <View style={style.leftTextContainer}>
            <TextLato style={style.leftTextTitle}>{i18n.t('discounts-table:prints-title')}</TextLato>
            {isDesktop && (
              <TextLato style={style.leftTextDescription}>{i18n.t('discounts-table:prints-subtitle')}</TextLato>
            )}
          </View>
        </View>
      )}

      <View style={style.rightElement}>
        {discount.map((elem: DiscountScale, index) => {
          const isLastElement = index === discount.length - 1;
          return (
            <View style={[style.tableRow, !isLastElement && style.border]} key={elem.discount}>
              <TextLato style={style.rowElementText}>
                {elem.to && elem.to != MAX_PHOTOS
                  ? i18n.t('discounts-table:prints-from-to', { from: elem.from, to: elem.to })
                  : i18n.t('discounts-table:prints-from-more', { from: elem.from })}
              </TextLato>
              <View
                style={[
                  style.rowRightElement,
                  isSmallDesktop ? style.rowRightElementInColumn : style.rowRightElementInRow,
                ]}
              >
                <View style={style.discountText}>
                  <TextLato style={[style.rowElementText, style.rowElementTextBold]}>
                    {i18n.t('discounts-table:price-discount', {
                      price: getFormattedPrice({ price: elem.basePrice, withCurrency: false }),
                    })}
                  </TextLato>
                  <TextLato style={style.rowElementText}>{i18n.t('discounts-table:unit-discount')}</TextLato>
                </View>
                <View>
                  {!!elem.discount && elem.discount != '0' && (
                    <TextLato style={style.discount}>{'-' + elem.discount + '%'}</TextLato>
                  )}
                </View>
              </View>
            </View>
          );
        })}
      </View>
    </View>
  );
};
